import React from "react";
import * as S from "./styled";
import Features from "./Features";
import Form from "./Form";
import PT from "prop-types";

const Subscribe = (props) => (
  <S.Wrap>
    <Form
      currency={props.currency}
      t={props.t}
      activateTrial={props.activateTrial}
      allowTrial={props.allowTrial}
      isActive={props.isActive}
      isTrial={props.isTrial}
      user={props.user}
      isFeaturesHidden={props.hideFeaturesList}
    />
    {!props.hideFeaturesList && <Features role={props.role} t={props.t} />}
  </S.Wrap>
);
Subscribe.propTypes = {
  allowTrial: PT.bool,
  isActive: PT.bool,
  isTrial: PT.bool,
  currency: PT.string,
  role: PT.string,
  user: PT.string,

  activateTrial: PT.func,
  t: PT.func.isRequired,
};
export default Subscribe;
